import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-dialog',
  templateUrl: './shared-warning-modal.component.html',
  styleUrl: './shared-warning-modal.component.scss',
  standalone: false
})
export class SharedWarningModalComponent {
  public data: { title: string; message: string; buttonText: string } = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<SharedWarningModalComponent>);

  constructor() {}

  onSubmit(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
